module.exports = __webpack_public_path__ + "img/august_1248_page.7f250a83.png";